import { RefObject, useState } from 'react';

import { useResizeObserver } from '@libs/hooks/useResizeObserver';

export function useTextLineCount(ref: RefObject<HTMLElement | null>) {
  const [lines, setLines] = useState(0);

  useResizeObserver(
    () => {
      const el = ref.current;
      if (!el) return setLines(0);

      const elHeight = el.clientHeight;
      let lineHeight = parseInt(el.style.lineHeight);
      if (!lineHeight) {
        const computedLineHeight = document.defaultView?.getComputedStyle(el, null).lineHeight;
        if (!computedLineHeight) {
          return setLines(0);
        }

        lineHeight = parseInt(computedLineHeight);
      }

      const lines = elHeight / lineHeight;
      setLines(Math.floor(lines));
    },
    [ref.current],
    ref,
  );

  return lines;
}
